import React, { lazy, ReactNode } from 'react';
import * as ROLES                           from 'Config/SystemRoles';

export interface IArguments {
  [key: string]: string|number;
}
export interface IRoute {
  path: string;
  Component?: typeof React.Component | React.LazyExoticComponent<any>;
  private?: boolean;
  arguments?: string[];
  access?: ({ key: string, name: string })[];
  sidebar?: {
    sorting?: number,
    icon?: string,
    label: ReactNode,
    render?: ReactNode;
  };
  children?: Record<string, IRoute>;
}

export const Routes: { [key: string]: IRoute } = {
  home: {
    path: '/',
    Component: lazy(() => import('View/Pages/HomePage/HomePage')),
    access: [ ROLES.SYSTEM_ADMIN, ROLES.ORGANISATION_OWNER ],
    private: true,
    sidebar: {
      label: 'Dashboard',
      sorting: 20,
      icon: 'desktop',
    }
  },
  organizer: {
    path: '/organisator',
    Component: lazy(() => import('View/Pages/OrganizerPage/OrganizerOverviewPage')),
    private: true,
    access: [ ROLES.SYSTEM_ADMIN, ROLES.ORGANISATION_OWNER ],
    sidebar: {
      label: 'Organisatoren',
      sorting: 100,
      icon: 'team',
    },
    children: {
      organizerEdit: {
        path: '/:id',
        Component: lazy(() => import('View/Pages/OrganizerPage/OrganizerDetailPage')),
      }
    }
  },
  appUser: {
    path: '/app-user',
    Component: lazy(() => import('View/Pages/AppUserPage/AppUserOverviewPage')),
    private: true,
    access: [ ROLES.SYSTEM_ADMIN ],
    sidebar: {
      label: 'User',
      sorting: 100,
      icon: 'user',
    },
    children: {
      appUserEdit: {
        path: '/:id',
        Component: lazy(() => import('View/Pages/AppUserPage/AppUserDetailPage')),
      }
    }
  },
  event: {
    path: '/event',
    Component: lazy(() => import('View/Pages/EventPage/EventOverviewPage')),
    private: true,
    access: [ ROLES.SYSTEM_ADMIN, ROLES.ORGANISATION_OWNER ],
    sidebar: {
      label: 'Events',
      sorting: 100,
      icon: 'star',
    },
    children: {
      eventEdit: {
        path: '/:id',
        Component: lazy(() => import('View/Pages/EventPage/EventDetailPage')),
        children: {
          eventEventTicketEdit: {
            path: '/event-ticket/:ticketId',
            Component: lazy(() => import('View/Pages/EventTicketPage/EventTicketDetailPage')),
          }
        }
      }
    }
  },
  eventCategory: {
    path: '/event-category',
    Component: lazy(() => import('View/Pages/EventCategoryPage/EventCategoryOverviewPage')),
    private: true,
    access: [ ROLES.SYSTEM_ADMIN ],
    sidebar: {
      label: 'Kategorien',
      sorting: 100,
      icon: 'tag',
    },
    children: {
      eventCategoryEdit: {
        path: '/:id',
        Component: lazy(() => import('View/Pages/EventCategoryPage/EventCategoryDetailPage')),
        children: {
          eventSubCategoryEdit: {
            path: '/sub-category/:eventCategoryId',
            Component: lazy(() => import('View/Pages/EventSubCategoryPage/EventSubCategoryDetailPage')),
          },
        }
      },

    }
  },
  invoice: {
    path: '/invoice',
    Component: lazy(() => import('View/Pages/InvoicePage/InvoiceOverviewPage')),
    private: true,
    access: [ ROLES.SYSTEM_ADMIN ],
    sidebar: {
      label: 'User-Rechnungen',
      sorting: 100,
      icon: 'invoice',
    },
    children: {
      invoiceDetail: {
        path: '/:id',
        Component: lazy(() => import('View/Pages/InvoicePage/InvoiceDetailPage')),
      }
    }
  },
  tickets: {
    path: '/tickets',
    Component: lazy(() => import('View/Pages/UserTicketPage/UserTicketOverviewPage')),
    private: true,
    access: [ ROLES.SYSTEM_ADMIN, ROLES.ORGANISATION_OWNER ],
    sidebar: {
      label: 'User-Tickets',
      sorting: 100,
      icon: 'pdf',
    },
    children: {
      userTicketDetail: {
        path: '/:id',
        Component: lazy(() => import('View/Pages/UserTicketPage/UserTicketDetailPage')),
      }
    }
  },
  employee: {
    path: '/be-nutzer',
    Component: lazy(() => import('View/Pages/EmployeePage/EmployeeOverviewPage')),
    private: true,
    access: [ ROLES.SYSTEM_ADMIN ],
    sidebar: {
      label: 'BE-Nutzer',
      sorting: 200,
      icon: 'employeeContract',
    },
    children: {
      employeeEdit: {
        path: '/:id',
        Component: lazy(() => import('View/Pages/EmployeePage/EmployeeDetailPage')),
      }
    }
  },
  settings: {
    path: '/settings',
    Component: lazy(() => import('View/Pages/SettingsPage/SettingsOverviewPage')),
    private: true,
    access: [ ROLES.SYSTEM_ADMIN ],
    sidebar: {
      label: 'Einstellungen',
      sorting: 200,
      icon: 'setting',
    },
  },

  login: {
    path: '/login',
    Component: lazy(() => import('View/Pages/LoginPage/LoginPage')),
  },
  logout: {
    path: '/logout',
    sidebar: {
      sorting: 1000,
      icon: 'logout',
      label: 'Abmelden',
    },
  },

};
